<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <span class="tl-title"></span>
      <div class="tl-stage">
        <span class="tl-line"></span>
        <div class="tl-points">
          <div
            v-for="(m, i) in milestones"
            :key="i"
            class="tl-point"
            :class="{ '--now': m.now }"
          >
            <span class="tl-dot"></span>
            <span class="tl-label" :class="{ '--now': m.now }">
              <span v-if="m.now" class="tl-now-pill">NOW</span>
              <span v-else class="tl-bar"></span>
            </span>
          </div>
        </div>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewTimeline',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
  data() {
    return {
      milestones: [
        { now: false },
        { now: false },
        { now: true },
        { now: false },
      ],
    }
  },
})
</script>

<style scoped lang="scss">
.tl-title {
  display: block;
  height: 12px;
  width: 40%;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.22);
}
.tl-stage {
  position: relative;
  flex: 1;
  min-height: 110px;
  display: flex;
  align-items: center;
  padding: 0 12px;
}
.tl-line {
  position: absolute;
  left: 12px;
  right: 12px;
  top: 50%;
  height: 2px;
  background: rgba(15, 15, 20, 0.14);
  transform: translateY(-50%);
}
.tl-points {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.tl-point {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.tl-dot {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  background: white;
  border: 2px solid color-mix(in srgb, var(--accent) 40%, rgba(15, 15, 20, 0.2));
}
.tl-point.--now .tl-dot {
  width: 14px;
  height: 14px;
  background: var(--accent);
  border-color: var(--accent);
  box-shadow: 0 0 0 4px color-mix(in srgb, var(--accent) 16%, transparent);
}
.tl-label {
  position: absolute;
  top: calc(50% + 14px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.tl-bar {
  display: block;
  height: 6px;
  width: 28px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.16);
}
.tl-now-pill {
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: var(--accent);
  background: color-mix(in srgb, var(--accent) 14%, white);
  border-radius: 999px;
  padding: 2px 6px;
}
</style>
